import { isInternationalTransfer } from 'src/core/utils/isInternationalTransfer';

type PaymentVerificationOfPayeeParams = {
  companyCurrency: string;
  targetCurrency: string;
  targetCountry: string | undefined;
  isWireTransferAvailable: boolean;
  iban?: string;
};

export const isPaymentVerificationOfPayeeCompatible = ({
  companyCurrency,
  targetCurrency,
  targetCountry,
  isWireTransferAvailable,
  iban,
}: PaymentVerificationOfPayeeParams): boolean => {
  const isNonInternationalEurPayment =
    companyCurrency === 'EUR' &&
    !isInternationalTransfer({
      sourceCurrency: companyCurrency,
      targetCurrency,
      targetCountry,
      iban,
    });

  return isNonInternationalEurPayment && isWireTransferAvailable;
};
